export const ROUTES = {
  HOME: "/",
  HOW_IT_WORKS: "/how-it-works",
  PRICING: "/pricing",
  FAQ: "/faq",
  CONTACT: "/contact",
  PRIVACY: "/privacy-policy",
  TERMS: "/terms",
  OWNER: "/owner",
  OWNER_LOGIN: "/owner/login",
  OWNER_DASHBOARD: "/owner/dashboard",
  SCAN: "/v/:vehicleId",
  INTERNAL: "/admin",
};

export const scanPath = (serial) => `/v/${serial}`;
